export const CENTER_CONSTANTS = {
    SEARCH: "CENTER__SEARCH",
    TODAY: "CENTER__TODAY",
    SECURITY: "CENTER__SECURITY",
    ACTIVITY: "CENTER__ACTIVITY",
    FAVORITES: "CENTER__FAVORITES",
    FAVORITE_TOGGLE: "CENTER__FAVORITE_TOGGLE",
    RELATIONS: "CENTER__RELATIONS",
    GLOBAL_TAGS: "CENTER__GLOBAL_TAGS",
    INBOX: "CENTER__INBOX",
    REMINDERS: "CENTER__REMINDERS",
    TEMPLATES: "CENTER__TEMPLATES",
    RUNBOOKS: "CENTER__RUNBOOKS",
    BACKUPS: "CENTER__BACKUPS",
    PROJECT_HEALTH: "CENTER__PROJECT_HEALTH",
    PROJECT_EXPORT: "CENTER__PROJECT_EXPORT",
    VERSIONS: "CENTER__VERSIONS",
    VERSIONS_ALL: "CENTER__VERSIONS_ALL",
    INBOX_RESTORE: "CENTER__INBOX_RESTORE",
    INBOX_REMOVE: "CENTER__INBOX_REMOVE",
    REMINDER_RESTORE: "CENTER__REMINDER_RESTORE",
    REMINDER_REMOVE: "CENTER__REMINDER_REMOVE",
    TEMPLATE_RESTORE: "CENTER__TEMPLATE_RESTORE",
    TEMPLATE_REMOVE: "CENTER__TEMPLATE_REMOVE",
    RUNBOOK_RESTORE: "CENTER__RUNBOOK_RESTORE",
    RUNBOOK_REMOVE: "CENTER__RUNBOOK_REMOVE",
    RUNBOOK_STEP_RESTORE: "CENTER__RUNBOOK_STEP_RESTORE",
    RUNBOOK_STEP_REMOVE: "CENTER__RUNBOOK_STEP_REMOVE",
    GLOBAL_TAG_RESTORE: "CENTER__GLOBAL_TAG_RESTORE",
    GLOBAL_TAG_REMOVE: "CENTER__GLOBAL_TAG_REMOVE",
};

export const CENTER_ENDPOINTS = {
    [CENTER_CONSTANTS.SEARCH]: "/control/search",
    [CENTER_CONSTANTS.TODAY]: "/control/today",
    [CENTER_CONSTANTS.SECURITY]: "/control/security-health",
    [CENTER_CONSTANTS.ACTIVITY]: "/control/activity",
    [CENTER_CONSTANTS.FAVORITES]: "/control/favorites",
    [CENTER_CONSTANTS.FAVORITE_TOGGLE]: "/control/favorites/toggle",
    [CENTER_CONSTANTS.RELATIONS]: "/control/relations",
    [CENTER_CONSTANTS.GLOBAL_TAGS]: "/control/global-tags",
    [CENTER_CONSTANTS.INBOX]: "/control/inbox",
    [CENTER_CONSTANTS.REMINDERS]: "/control/reminders",
    [CENTER_CONSTANTS.TEMPLATES]: "/control/templates",
    [CENTER_CONSTANTS.RUNBOOKS]: "/control/runbooks",
    [CENTER_CONSTANTS.BACKUPS]: "/control/backups",
    [CENTER_CONSTANTS.PROJECT_HEALTH]: "/control/projects/:id/health",
    [CENTER_CONSTANTS.PROJECT_EXPORT]: "/control/projects/:id/export",
    [CENTER_CONSTANTS.VERSIONS]: "/control/versions/:entityType/:entityId",
    [CENTER_CONSTANTS.VERSIONS_ALL]: "/control/versions",
    [CENTER_CONSTANTS.INBOX_RESTORE]: "/control/inbox/:id/restore",
    [CENTER_CONSTANTS.INBOX_REMOVE]: "/control/inbox/:id",
    [CENTER_CONSTANTS.REMINDER_RESTORE]: "/control/reminders/:id/restore",
    [CENTER_CONSTANTS.REMINDER_REMOVE]: "/control/reminders/:id",
    [CENTER_CONSTANTS.TEMPLATE_RESTORE]: "/control/templates/:id/restore",
    [CENTER_CONSTANTS.TEMPLATE_REMOVE]: "/control/templates/:id",
    [CENTER_CONSTANTS.RUNBOOK_RESTORE]: "/control/runbooks/:id/restore",
    [CENTER_CONSTANTS.RUNBOOK_REMOVE]: "/control/runbooks/:id",
    [CENTER_CONSTANTS.RUNBOOK_STEP_RESTORE]: "/control/runbook-steps/:id/restore",
    [CENTER_CONSTANTS.RUNBOOK_STEP_REMOVE]: "/control/runbook-steps/:id",
    [CENTER_CONSTANTS.GLOBAL_TAG_RESTORE]: "/control/global-tags/:id/restore",
    [CENTER_CONSTANTS.GLOBAL_TAG_REMOVE]: "/control/global-tags/:id",
};
